import {LocalizedEventEntity} from '../event-legacy/localized-event.entity';
import {LocalizedEventTypeEntity} from '../event-type-legacy/localized-event-type.entity';

export class EventPerformanceEntity {
  public constructor(public eventType: LocalizedEventTypeEntity, public event: LocalizedEventEntity) {}
}
